import { Suspense, lazy } from 'react'
import { Outlet } from 'react-router-dom'
// auth
import { RoleBasedGuard } from 'src/auth/guard'
// layouts
// components
import { LoadingScreen } from 'src/components/loading-screen'
import DashboardLayout from 'src/layout/dashboard/layout'
import EventCreateEditView from 'src/pages/dashboard/events/events-create-edit-view'
import EventsListView from 'src/pages/dashboard/events/list'
import TicketValidationView from 'src/pages/dashboard/events/ticket-validation/ticket-validation-view'
import OrdersListView from 'src/pages/dashboard/orders/list'
import ProductsListView from 'src/pages/dashboard/products/list'
import StockListView from 'src/pages/dashboard/stock/list'
import ReportsListView from 'src/pages/dashboard/reports/list'
import SellerPerformance from 'src/pages/dashboard/seller-performance'
import ProductsAnalysis from 'src/pages/dashboard/products-analysis'
import FechamentoView from 'src/pages/dashboard/fechamento'
import AuditView from 'src/pages/dashboard/audit'
import FinanceView from 'src/pages/dashboard/finance'
import SettingsPage from 'src/pages/dashboard/settings'
import TransactionList from 'src/pages/dashboard/transaction/list'
import TransactionListById from 'src/pages/dashboard/transaction/listTransacions/list'
import UserListView from 'src/pages/dashboard/users/list'

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/home'))

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <RoleBasedGuard hasContent roles={['admin', 'franchisee']}>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </RoleBasedGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'seller-performance', element: <SellerPerformance /> },
      { path: 'products-analysis', element: <ProductsAnalysis /> },
      { path: 'settings', element: <SettingsPage /> },
      {
        path: 'users',
        children: [{ element: <UserListView />, index: true }],
      },
      {
        path: 'products',
        children: [{ element: <ProductsListView />, index: true }],
      },
      {
        path: 'stock',
        children: [{ element: <StockListView />, index: true }],
      },
      {
        path: 'events',
        children: [
          {
            element: <EventsListView />,
            index: true,
          },
          { element: <EventCreateEditView />, path: 'create' },
          { element: <TicketValidationView />, path: 'ticket-validation' },
          { element: <EventCreateEditView />, path: ':id' },
        ],
      },
      {
        path: 'orders',
        children: [{ element: <OrdersListView />, index: true }],
      },
      {
        path: 'reports',
        children: [{ element: <ReportsListView />, index: true }],
      },
      {
        path: 'fechamento',
        children: [{ element: <FechamentoView />, index: true }],
      },
      {
        path: 'audit',
        children: [
          {
            element: (
              <RoleBasedGuard hasContent roles={['admin']}>
                <AuditView />
              </RoleBasedGuard>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'finance',
        children: [
          {
            element: (
              <RoleBasedGuard hasContent roles={['admin']}>
                <FinanceView />
              </RoleBasedGuard>
            ),
            index: true,
          },
        ],
      },
      {
        path: 'transaction',
        children: [
          {
            element: <TransactionList />,
            index: true,
          },
          { element: <TransactionListById />, path: ':id' },
        ],
      },
    ],
  },
]
